<template>
  <v-container>
    <v-layout align-center justify-center>
      <v-row>
        <v-col align="center" v-show="mostrarBotonCerrar"> </v-col>
      </v-row>
      <v-row v-show="mostrarSoftphone">
        <v-col align="center">
          <v-row justify="center">
            <v-col cols="6">
              <v-text-field
                v-show="verBoton"
                class="centered-input"
                style="font-size: 1.6rem"
                v-model="numeroDestino"
                :append-outer-icon="'mdi-backspace'"
                type="text"
                @click:append-outer="vaciar()"
              />
            </v-col>
          </v-row>

          <numericpad v-show="verTeclado" :onInput="onInput" />

          <v-row v-show="llamadaEntranteVentana">
            <v-col>
              <p style="font-size: 2.6rem">{{ this.nombreLLamadaEntrante }}</p>
              <v-row>
                <v-col>
                  <v-btn
                    v-show="!llamadaEntranteVentanaTime"
                    color="error"
                    large
                    fab
                    @click="rechazarLlamada()"
                  >
                    <v-icon>mdi-phone-hangup</v-icon>
                  </v-btn>
                </v-col>

                <v-col>
                  <v-btn
                    large
                    fab
                    v-show="!llamadaEntranteVentanaTime"
                    color="success"
                    @click="aceptarLlamada()"
                  >
                    <v-icon>mdi-phone</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row
            v-show="llamadaIniciadaVentada || llamadaEntranteVentanaTime"
            outlined
            color="transparent"
          >
            <v-col>
              <div>
                <p style="font-size: 2.6rem">{{ numeroDestino }}</p>
              </div>
              <cronometro />

              <v-row>
                <v-col class="col-md-8 offset-md-2">
                  <v-row>
                    <v-col>
                      <mute-boton />
                    </v-col>
                    <v-col>
                      <pausar-boton />
                    </v-col>
                    <v-col>
                      <transferir-boton />
                    </v-col>
                  </v-row>

                  <v-row>
                    <colgar-boton color="error" v-show="vercolgar" />
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-row class="mt-md-4">
            <llamar-boton
              v-show="!vercolgar && verBoton"
              v-bind:itemEntrada="numeroDestino"
            />
            <colgar-boton v-show="verBoton && vercolgar" />
            <video ref="probavideo" width="1px" height="10px" autoPlay />
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-snackbar
          v-model="snackbar"
          :bottom="true"
          :right="true"
          :timeout="3000"
          :color="snack_color"
        >
          {{ snack_text }}
        </v-snackbar>
      </v-row>
    </v-layout>
  </v-container>
</template>
<script>
import PhoneCommander from "./phoneCommander";
import numericpad from "./numeric-keypad.vue";
import store from "./store";
import llamarBoton from "./llamarBoton";
import colgarBoton from "./colgarBoton";
import cronometro from "./cronometro";
import muteBoton from "./muteBoton";
import pausarBoton from "./pausarBoton";
import transferirBoton from "./transferirBoton";

export default {
  components: {
    numericpad,
    llamarBoton,
    colgarBoton,
    cronometro,
    muteBoton,
    pausarBoton,
    transferirBoton,
  },
  data: () => ({
    maxLength: 15,
    snackbar: false,
    snack_color: "",
    snack_text: "",
    nombreLLamadaEntrante: "",
    mostrarSoftphone: false,
    llamadaIniciada: false,
    numeroDestino: "",
    myInstance: "",
    estadoCerrar: false,
    mostrarBotonCerrar: false,
    mostrarFormulario: true,
    llamadaIniciadaVentada: false,
    llamadaEntranteVentana: false,
    llamadaEntranteVentanaTime: false,
    enLlamada: false,
    vTeclado: false,
    verTeclado: true,
    verBoton: true,
    vercolgar: false,
  }),
  props: {
    extensionCompleta: { required: true },
    passwordExtension: { required: true },
    modoDebug: { default: "none" },
  },
  methods: {
    onInput(key) {
      if (this.enLlamada == false) {
        this.numeroDestino = (this.numeroDestino + key).slice(
          0,
          this.maxLength
        );
      }
    },

    go(msg, color) {
      this.snack_text = msg;
      this.snack_color = color;
      this.snackbar = true;
    },
    registrar() {
      const debug = this.modoDebug;
      const videoTagRef = this.$refs.probavideo;
      var sipIdentity = "sip:" + this.extensionCompleta;
      var secretPass = this.passwordExtension;
      var userauth = sipIdentity.split(":")[1].split("@")[0];
      var dispName = userauth.split("-")[1];
      var sipRegistrar = "sip:" + sipIdentity.split("@")[1];

      const sipPluginConfig = {
        sipIdentity: sipIdentity,
        displayName: dispName,
        sipRegistrar: sipRegistrar,
        username: userauth,
        secret: secretPass,
      };

      this.myInstance = new PhoneCommander(sipPluginConfig, debug, videoTagRef);
      this.myInstance.connect();
      store.commit("SET_INSTANCIAPHONE", this.myInstance);
      store.commit("SET_REGISTRO", this.myInstance.registro);
    },

    aceptarLlamada() {
      this.numeroDestino = "";
      store.commit("SET_VERCOLGAR", true);
      this.verBoton = false;
      store.getters.getinstanciaPhone.acceptCall();
      this.llamadaEntranteVentanaTime = true;
      store.commit("SET_NOMBRELLAMADAENTRANTE", "");
      store.commit("SET_INICIARBOTONERA", true);
    },
    rechazarLlamada() {
      this.llamadaEntranteVentana = false;
      this.enLlamada = false;
      this.verBoton = true;
      this.verTeclado = true;
      this.myInstance.declineCall();
      store.commit("SET_NOMBRELLAMADAENTRANTE", "");
      this.myInstance.nombreLLamadaEntrante = "";
    },
    desconectar() {
      this.mostrarFormulario = false;
      this.mostrarBotonCerrar = false;
      this.myInstance.disconnect();
      this.estadoCerrar = true;
      this.go("Cerrando softpohone.", "error");
    },
    vaciar() {
      if (!this.llamadaEntranteVentanaTime && !this.llamadaIniciadaVentada) {
        this.numeroDestino = this.numeroDestino.slice(0, -1);
      }
    },
  },
  computed: {
    VLlamadaEstado() {
      return store.getters.getllamadaEstado;
    },
    Vregistered() {
      return store.getters.getregistro;
    },
    VincommingCall() {
      return store.getters.getnombreLLamadaEntrante;
    },
    Vcolgar() {
      return store.getters.getverColgar;
    },
  },

  watch: {
    VLlamadaEstado(value) {
      if (value == "accepted") {
        if (this.llamadaEntranteVentana != true) {
          this.llamadaIniciadaVentada = true;
          this.enLlamada = true;
          this.verBoton = false;
          this.verTeclado = false;
        }

        store.commit("SET_STATECRONO", "started");
        store.commit("SET_LLAMADAESTADO", "intermedio");
      }
      if (value == "hangup") {
        store.commit("SET_INICIARBOTONERA", false);
        this.numeroDestino = "";
        this.vercolgar = false;
        store.commit("SET_VERCOLGAR", false);
        store.commit("SET_STATECRONO", "reset");
        this.llamadaEntranteVentana = false;
        this.llamadaEntranteVentanaTime = false;
        this.llamadaIniciadaVentada = false;
        this.enLlamada = false;
        this.verBoton = true;
        this.verTeclado = true;
        store.commit("SET_LLAMADAESTADO", "intermedio");
      }
      if (value == "transferenciaNotificada") {
        store.commit("SET_INICIARBOTONERA", false);
        this.numeroDestino = "";
        this.vercolgar = false;
        store.commit("SET_VERCOLGAR", false);
        store.commit("SET_STATECRONO", "reset");
        this.llamadaEntranteVentana = false;
        this.llamadaEntranteVentanaTime = false;
        this.llamadaIniciadaVentada = false;
        this.enLlamada = false;
        this.verBoton = true;
        this.verTeclado = true;
      }
    },
    Vcolgar(value) {
      if (value) {
        this.vercolgar = true;
      } else {
        this.vercolgar = false;
      }
    },
    Vregistered(value) {
      var phoneRetorno = store.getters.getinstanciaPhone;
      if (store.getters.getregistro == true) {
        this.go("Registrado", "success");
        this.mostrarBotonCerrar = true;
        this.mostrarFormulario = false;
        this.mostrarSoftphone = true;
      } else {
        if (this.estadoCerrar == false) {
          if (phoneRetorno.registro == true) {
            this.mostrarFormulario = true;
            this.mostrarSoftphone = false;
          }
          if (store.getters.getregistro == false) {
            this.go("No Registra, vuelva a intentarlo", "error");
            this.mostrarFormulario = true;
            this.mostrarSoftphone = false;
          }
        } else {
          if (store.getters.getregistro == false) {
            this.estadoCerrar = false;
            this.mostrarFormulario = true;
            this.mostrarSoftphone = false;
          }
          this.mostrarFormulario = true;
          this.mostrarSoftphone = false;
        }
      }
    },

    VincommingCall(value) {
      if (value != "") {
        this.verBoton = false;
        if (value.includes(":") && value.includes("@")) {
          value = value.split(":")[1].split("@")[0];
        }
        store.commit("SET_NOMBRELLAMADAENTRANTE", value);
        this.nombreLLamadaEntrante = value;
        this.llamadaEntranteVentana = true;
        if (this.vTeclado) {
          this.enLlamada = false;
          this.verTeclado = true;
        } else {
          this.enLlamada = true;
          this.verTeclado = false;
        }
      }
    },
  },
};
</script>
<style scoped>
.centered-input >>> input {
  text-align: center;
}
</style>

